<template>
    <div
        class="form-check"
        v-bind:class="wrapperClasses"
        no-interact>
        <input
            v-bind="binder"
            ref="input"
            v-model="internalValue"
            v-bind:indeterminate="indeterminate"
            v-bind:disabled="disabled || readonly"
            v-bind:role="inputRole"
            v-bind:required="required"
            v-bind:aria-invalid="hasValidationError"
            v-bind:aria-describedby="validationErrorId"
            class="form-check-input"
            type="checkbox"
            v-on="listeners" />
        <label
            v-bind:for="internalId"
            class="form-check-label d-inline"
            v-bind:class="labelClasses">
            {{ label }}
        </label>
        <!-- we need to put these here manually because of how the custom label expects the dom to be,
        which means that we cant use the pc-label -->
        <span
            v-if="required"
            class="text-danger">
            *
        </span>
        <pc-help-icon
            v-if="showHelp"
            v-bind:help-link="helpLink"
            v-on:click="$emit('help-clicked', $event)" />
        <div
            v-if="showValidationErrors"
            v-bind:id="validationErrorId"
            class="invalid-feedback fw-bold">
            {{ validationError }}
        </div>
    </div>
</template>

<script>
    import base from "./_inputBase.vue";
    export default {
        extends: base,
        props: {
            modelValue: { type: Boolean, required: false, default: null },
            useIndeterminate: { type: Boolean, required: false, default: false },
            switch: { type: Boolean, required: false, default: false }
        },
        emits: ["help-clicked"],
        data() {
            return {
                overrideGetNewValueFn: this.getValueOverride
            };
        },
        computed: {
            indeterminate() {
                return !this.switch && this.useIndeterminate && this.modelValue === null;
            },
            wrapperClasses() {
                return { "form-switch": this.switch };
            },
            overrideInputClasses() {
                return { "rounded-pill": this.switch };
            },
            inputRole() {
                return this.switch ? "switch" : "checkbox";
            },
            labelClasses() {
                return {
                    "fw-bold": this.labelBinder?.bold ?? false,
                    "fst-italic": this.labelBinder?.italic ?? false
                };
            }
        },
        methods: {
            // When checkboxes fire the change event, the event target value reflects
            // the current state of the checkbox, not the new state. For checkboxes,
            // we need to get the new value from the "checked" attribute instead.
            getValueOverride(eventTarget) {
                return eventTarget.checked;
            }
        }
    };
</script>
